import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./controllers/store";
import { I18nextProvider } from "react-i18next";
import i18n from "./controllers/translations";

/**
 * AVOID PRINT RELEVANT DATA IN PROD ENV
 */
if (process.env.REACT_APP_ENV == "production") {
  console.log = () => { };
  console.info = () => { };
  console.warn = () => { };
  console.error = () => { };
  try {
    process.on("uncaughtException", () => { });
    process.on("unhandledRejection", () => { });
  } catch (e) { }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
